var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.9,
    height: 9.9,
    viewBox: "0 0 9.9 9.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_556",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 556",
    transform: "translate(-43.05 -36.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1608",
    "data-name": "\\u9577\\u65B9\\u5F62 1608",
    width: 2,
    height: 12,
    transform: "translate(43.05 37.464) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1609",
    "data-name": "\\u9577\\u65B9\\u5F62 1609",
    width: 2,
    height: 12,
    transform: "translate(44.464 45.95) rotate(-135)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.7203cb21d2b4767aa6d090c1c7826777.svg";
export { ForwardRef as ReactComponent };